import React, { FC } from 'react'
import { FooterProps } from '@at/design-system-patterns'
import { ConnectedFooter } from '@at/connected-footer'

import { useSearchViewState } from '../../contexts/search-view-state-context'
import { useCheckPlatform } from '../../hooks/use-check-platform.hook'
import { useChannel } from '../../hooks/use-abtest.hook'

const Footer: FC<Partial<FooterProps>> = () => {
    const { platform } = useCheckPlatform()
    const { showFooter } = useSearchViewState()
    const channel = useChannel()

    if (!showFooter) return null

    return (
        <div id="footer-container">
            <ConnectedFooter channel={channel} platform={platform} />
        </div>
    )
}

export { Footer }
